import { render, staticRenderFns } from "./single.vue?vue&type=template&id=47b7f481&scoped=true"
import script from "./single.vue?vue&type=script&lang=js"
export * from "./single.vue?vue&type=script&lang=js"
import style0 from "./single.vue?vue&type=style&index=0&id=47b7f481&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b7f481",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b7f481')) {
      api.createRecord('47b7f481', component.options)
    } else {
      api.reload('47b7f481', component.options)
    }
    module.hot.accept("./single.vue?vue&type=template&id=47b7f481&scoped=true", function () {
      api.rerender('47b7f481', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/statistic/single.vue"
export default component.exports